import React from 'react';
import UploadCatalogoFornecedor from '../UploadCatalogoFornecedor/UploadCatalogoFornecedor';

type Props = { closeAction: Function; closeActionSimple: Function };

const UploadCardapioWeb: React.FC<Props> = (props) => <UploadCatalogoFornecedor {...props}
  source={"CARDAPIO_WEB"} title={"Importar catálogo Cardápio Web"}
  instructions={"Copie a URL do cardápio digital da sua loja no Cardápio Web."}
  placeholder={"https://app.cardapioweb.com/sua-loja"} />;

export default UploadCardapioWeb;
